import { convertToPixelFromVH, convertToPixelFromVW } from "../../utils/ViewportUtils";

export const CustomLegend = ({ payload }: any) => {
    return (
        <ul style={{ display: 'flex', gap: '0.33vw', listStyleType: 'none', padding: 0 }}>
            {payload.map((entry: any, index: number) => (
                <li key={`item-${index}`} style={{
                    minWidth: '2vw',
                    display: 'flex',
                    alignItems: 'center',
                    border: `0.075vw solid ${entry.color}`,
                    borderRadius: '1vw',
                    padding: "0.125vw 0.5vw",
                }}>
                    <svg width={convertToPixelFromVW(1)} height={convertToPixelFromVH(2)} viewBox={`0 0 ${convertToPixelFromVW(1)} ${convertToPixelFromVH(2)}`}>
                        <circle cx={convertToPixelFromVW(1) / 2} cy={convertToPixelFromVH(2) / 2} r={convertToPixelFromVH(1) / 1.5} fill={entry.color} />
                    </svg>
                    <span style={{ color: '#242E35' }}>{entry.value}</span>
                </li>
            ))}
        </ul>
    );
};